module.exports = __webpack_public_path__ + "static/img/5308_phase_function_Paper_Points.452367d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5308_phase_function_Paper_Points.png
// module id = 8nlw
// module chunks = 0